import firebase from 'firebase/app';
import 'firebase/auth';
import { addUserReading } from '../firebase/user';

const SERVICE_UUID = '14839ac4-7d7e-415c-9a42-167340cf2339';
const WRITE_UUID = '8b00ace7-eb0b-49b0-bbe9-9aee0a26e1a3';
const READ_UUID = '0734594a-a8e7-4b1a-a6b1-cd5243059a57';

function computeCRC8(data) {
  const table = [...Array(256)].map((_, i) => {
    let crc = i;
    for (let j = 0; j < 8; j++) {
      crc = (crc & 0x80) ? ((crc << 1) ^ 0x07) & 0xFF : (crc << 1) & 0xFF;
    }
    return crc;
  });
  return data.reduce((crc, byte) => table[crc ^ byte], 0);
}

let partialJson = '';
let spo2Readings = [];
let spo2AvgComputed = false;

export async function onGlucoseMonitorDeviceButtonClick() {
  try {
    const user = firebase.auth().currentUser;

    if (!user || !user.uid) {
      console.error('❌ No UID passed to glucose monitor. Cannot upload reading.');
      return;
    }

    const uid = user.uid;

    //console.log('Requesting Bluetooth Device...');
    const device = await navigator.bluetooth.requestDevice({
      acceptAllDevices: true,
      optionalServices: [SERVICE_UUID],
    });

    console.log('Connecting to GATT Server...');
    const server = await device.gatt.connect();
    const service = await server.getPrimaryService(SERVICE_UUID);

    const writeChar = await service.getCharacteristic(WRITE_UUID);
    const readChar = await service.getCharacteristic(READ_UUID);

    console.log('✅ Notifications set up successfully!');
    await readChar.startNotifications();

    readChar.addEventListener('characteristicvaluechanged', (event) => {
      const value = event.target.value;
      const data = new Uint8Array(value.buffer);
      const ascii = String.fromCharCode(...data);
      const hexString = [...data].map(b => b.toString(16).padStart(2, '0')).join(' ');

      console.log('Raw Data:', hexString);
      console.log('ASCII Guess:', ascii);

      const isJsonLike = ascii.includes('{') || ascii.includes('Model') || ascii.includes('"');

      if (isJsonLike) {
        partialJson += ascii;
        const likelyComplete = partialJson.trim().endsWith('}') || partialJson.length > 300;

        if (likelyComplete) {
          try {
            const json = JSON.parse(partialJson);
            console.log('✅ Complete JSON received:', json);
            partialJson = '';
            if (json.glucose) {
              console.log('🧪 Glucose Reading:', json.glucose, 'mg/dL');
            }
            if (json.Region || json.SN || json.Model) {
              console.log('📦 Device Info:', json);
            }
          } catch (e) {
            console.log('⚠️ JSON not complete or malformed yet. Waiting...');
          }
        } else {
          console.log('Waiting for more JSON fragments...');
        }

        return;
      }

      if (data.length >= 20 && data[0] === 0x55) {
        const payload = data.slice(7, 20);
        const spo2 = payload[0];
        const pr = payload[1] | (payload[2] << 8);

        console.log('🩸 SpO2:', spo2 + '%');
        console.log('❤️ Pulse:', pr + ' bpm');

        if (spo2 > 0 && spo2 <= 100 && spo2Readings.length < 5) {
          spo2Readings.push(spo2);
          console.log(`📊 SpO2 Reading ${spo2Readings.length}: ${spo2}%`);
        }

        if (spo2Readings.length === 5 && !spo2AvgComputed) {
          const avgSpO2 = spo2Readings.reduce((a, b) => a + b, 0) / 5;
          console.log(`✅ Average of first 5 SpO2 readings: ${avgSpO2.toFixed(2)}%`);

          addUserReading({
            uid: uid,
            add: {
              devices: {
                glucoseMonitor: {
                  date: new Date().toLocaleDateString("en-CA"), // Format: YYYY-MM-DD
                  time: new Date().toLocaleTimeString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  }),
                  note: `Bluetooth Glucose Monitor ᛒ (avgSpO2: ${avgSpO2.toFixed(2)}%)`,
                  status: "Accepted",
                  device: {
                    manufacturer: "Generic",
                    model: "PulseOxi-BT",
                  },
                  reading: {
                    avgSpO2: avgSpO2.toFixed(2),
                  }
                }
              }
            }
          });

          spo2AvgComputed = true;
        }

        return;
      }

      console.log('⚠️ Unclassified packet, skipping.');
    });

    const CMD = 0x14;
    const pkt = [0xAA, CMD, ~CMD & 0xFF, 0x00, 0x00, 0x00, 0x00];
    const crc = computeCRC8(pkt);
    const command = new Uint8Array([...pkt, crc]);
    console.log('Sending command to get device info...');
    await writeChar.writeValue(command);

    setInterval(async () => {
      if (spo2Readings.length < 5) {
        const spo2Pkt = [0xAA, 0x17, ~0x17 & 0xFF, 0x00, 0x00, 0x00, 0x00];
        const spo2Crc = computeCRC8(spo2Pkt);
        const spo2Cmd = new Uint8Array([...spo2Pkt, spo2Crc]);
        console.log('Polling SpO2...');
        await writeChar.writeValue(spo2Cmd);
      }
    }, 2000);

  } catch (err) {
    //console.error('Bluetooth Error:', err);
  }
}
